import { camelCase, set, get } from 'lodash';
import { sentenceCase, toLowerCaseFirstLetter } from './StringUtilities';
export var errorCodeLocalizer = function (codes, error) {
    if (isDomainValidationError(error)) {
        return (!!error.code && get(codes, error.code, null)) || error.message;
    }
    return (!!error.errorCode && get(codes, error.errorCode, null)) || error.errorMessage;
};
export function isDomainValidationError(errorPayload) {
    var typedPayload = errorPayload;
    return typedPayload.code !== undefined && typedPayload.content !== undefined;
}
export function getFirstErrorMessageFromApiError(result, codes, defaultMessage) {
    if (isDomainValidationError(result)) {
        if (result.content && result.content.length > 0) {
            if (codes)
                return errorCodeLocalizer(codes, result.content[0]);
            return result.content[0].errorMessage;
        }
        if (codes)
            return errorCodeLocalizer(codes, result);
    }
    var message = null;
    if (result instanceof Error) {
        message = result.message;
    }
    return message || defaultMessage || 'Api Error';
}
export function toNullableKeys(form) {
    var returnObject = {};
    Object.keys(form).forEach(function (key) {
        returnObject[key] = null;
    });
    return returnObject;
}
/**
 * Converts our convention based API validation error result into a usable error block and global errors list.
 */
export function convertValidationResultToErrorsObjectV2(results, codes, propertyNameConverter) {
    var fieldErrors = {};
    var hasApiErrors = false;
    if (!results) {
        return {
            fieldErrors: {},
            hasApiErrors: false
        };
    }
    if (results.length > 0) {
        hasApiErrors = true;
        results.forEach(function (it) {
            var propertyName = propertyNameConverter ? propertyNameConverter(it.propertyName) : it.propertyName;
            var lowerCasePropertyName = propertyName.split('.').map(toLowerCaseFirstLetter).join('.');
            set(fieldErrors, lowerCasePropertyName, codes ? errorCodeLocalizer(codes, it) : it.errorMessage);
        });
    }
    return {
        fieldErrors: fieldErrors,
        hasApiErrors: hasApiErrors
    };
}
/**
 * Converts our convention based API validation error result into a usable error block and global errors list.
 */
export function convertValidationResultToErrorsObject(_a) {
    var result = _a.result, formStructure = _a.formStructure;
    if (!result) {
        return {
            formErrors: {},
            hasFormErrors: false,
            apiErrors: [],
            hasApiErrors: false
        };
    }
    return result.reduce(function (errorObject, validationError) {
        var propertyName = validationError.propertyName, errorMessage = validationError.errorMessage;
        var adjustPropertyName = camelCase(propertyName);
        if (formStructure.hasOwnProperty(adjustPropertyName)) {
            errorObject.hasFormErrors = true;
            if (!errorObject.formErrors.hasOwnProperty(adjustPropertyName)) {
                errorObject.formErrors[adjustPropertyName] = errorMessage;
            }
        }
        else {
            errorObject.hasApiErrors = true;
            if (!errorObject.apiErrors.some(function (error) { return error === errorMessage; })) {
                var message = errorMessage;
                if (message === 'This field is required')
                    message = errorMessage + " (" + sentenceCase(adjustPropertyName) + ")";
                errorObject.apiErrors.push(message);
            }
        }
        return errorObject;
    }, {
        formErrors: {},
        hasFormErrors: false,
        apiErrors: [],
        hasApiErrors: false
    });
}
